var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.version)?_c('div',{staticClass:"product-version-badge"},[_vm._v(" Thai Smart Tax "+_vm._s(_vm.version)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }